import { makeActionCreator } from '@/utils';
import { referenceDataSlice } from './slice';

const createAction = makeActionCreator(referenceDataSlice.name);

export const fetchReferenceData = createAction('fetchReferenceData');
export const fetchReferenceDataFailed = createAction(
  'fetchReferenceDataFailed',
);
export const {
  setReferenceData,
  setReferenceDataLoading,
  setReferenceDataFailed,
} = referenceDataSlice.actions;
